/*
 * =============================================================================
 * Project: boilerplate
 * Created Date: 2018-03-12, 09:01:06
 * Author: Przemysław Drzewicki <przemyslaw.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-03-19, 13:20:57
 * Modified By: Przemysław Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada S.A
 * =============================================================================
 */
import React from 'react';
import { Card, Spin, Form, Button, Input, Row, Col } from "antd";

const FormItem = Form.Item;
import { required, email } from "helpers/rules";

export default component =>
  (
    <Card className="login"
      title="Logowanie użytkownika">
      <Spin tip="Loguje użytkownika..."
        spinning={component.state.loading}>
        {component.state.message}
        <Form className="login__form"
          onSubmit={component.loginUserToPlatform.bind(component)}>
          <FormItem 
            hasFeedback={true}
            label="E-mail użytkownika"
          >
            {component.props.form.getFieldDecorator("email", {
              rules: [required(), email()]
            })(<Input placeholder="Wpisz e-mail użytkownika" />)}
          </FormItem>
          <FormItem 
            hasFeedback={true}
            label="Hasło użytkownika"
          >
            {component.props.form.getFieldDecorator("password", {
              rules: [required()]
            })(<Input type="password"
              placeholder="Wpisz hasło użytkownika" />)}
          </FormItem>
          <FormItem className="text-right">
            <br/>
            <Button type="primary"
              htmlType="submit"
              size="large">
                Zaloguj się
            </Button>
            <br/>
          </FormItem>
        </Form>
      </Spin>
    </Card>
  )


// WEBPACK FOOTER //
// ./src/rcapp/components/authorization/login/template.js